import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import { Row, Col, Card, Form, DatePicker } from 'antd';
import { isEmpty } from '../../../util/isEmpty';
import moment from 'moment';
import 'antd/dist/antd.css';

const { WeekPicker } = DatePicker;

class ScheduleRateFilter extends Component {
  constructor(props) {
    super(props);
    // Initial state
    this.state = {
      selectedEtdRange: (props?.schedule_etd_range ? this.getDateRange(props?.schedule_etd_range) : null),
      selectedEtaRange: (props?.schedule_eta_range ? this.getDateRange(props?.schedule_eta_range) : null),
      etdRange: props?.schedule_etd_range,
      etaRange:props?.schedule_eta_range,
      filteredFcl: [],
      availableWeeksForEtd: [],
      availableWeeksForEtaDestination: [],
      disabledWeeks: []  // Keep track of disabled weeks
    };
  }
  // Helper: Get week range from a given date
  getWeekRange = (date) => {
    const mDate = moment(date);
    return {
      startOfWeek: mDate.startOf('week').format('YYYY-MM-DD'),
      endOfWeek: mDate.endOf('week').format('YYYY-MM-DD'),
    };
  };

  // Shared Helper: Extract unique weeks from rates based on date field
  getAvailableWeeks = (rates, dateGetter) => {
    const filteredRates = this.getFilteredBlockRoutesRates(rates);
    const uniqueWeeks = new Set();

    const availableWeeks = [];

    filteredRates.forEach(rate => {
      const date = dateGetter(rate);
      if (date) {
        const { startOfWeek, endOfWeek } = this.getWeekRange(date);
        const key = `${startOfWeek}_${endOfWeek}`;

        if (!uniqueWeeks.has(key)) {
          uniqueWeeks.add(key);
          availableWeeks.push({ startOfWeek, endOfWeek });
        }
      }
    });

    return availableWeeks;
  };

  // Extract ETD-based available weeks
  getAvailableWeeksForEtd = (rates) => {
    const availableWeeksForEtd = this.getAvailableWeeks(rates, rate => rate?.schedules?.etd);
    // console.log("--availableWeeksForEtd---", availableWeeksForEtd);
    this.setState({ availableWeeksForEtd });
  };

  // Extract ETA Destination-based available weeks
  getAvailableWeeksForEta = (rates) => {
    const availableWeeksForEtaDestination = this.getAvailableWeeks(
      rates,
      rate => rate?.schedules?.etaPortOfDestination || rate?.schedules?.eta_destination
    );
    // console.log("--availableWeeksForEtaDestination---", availableWeeksForEtaDestination);
    this.setState({ availableWeeksForEtaDestination });
  };

  // Filter out blocked routes (if any)
  getFilteredBlockRoutesRates = (rates) => {
    const filtered = rates.filter(rate => rate.blockRoute === false);
    return filtered.length ? filtered : rates;
  };

  getDateRange = (date) => {
    const startOfWeek = date?.startOf('week')?.format('DD-MMMM-YYYY');
    const endOfWeek = date?.endOf('week')?.format('DD-MMMM-YYYY');
    
    const selectedRange = startOfWeek && endOfWeek ? `${startOfWeek} to ${endOfWeek}` : null;
    return selectedRange;
  };
  

  // ETD WeekPicker Handler
  handleEtdChange = async (date, dateString) => {
    // console.log("handleEtdChange....",date,dateString)
    const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;

    const jsonData =
      (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
      (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
      (!isEmpty(airJSON) && airJSON) ||
      {};
    //console.log("jsonData?.rates?.fcl: ",jsonData?.rates?.fcl)
    const fclRates = jsonData?.rates?.fcl

    const selectedCarrier = this.props.selectedCarrier
    
    this.setState({etdRange: date })
    this.props.setSelectedEtdRangeSchedule(date)
    const dateRange = this.getDateRange(date);
    this.setState({ selectedEtdRange: dateRange });
    const filteredFclArr = await this.props.filterRatesByEtaEtd(this.state.etaRange, date, selectedCarrier);
    // console.log("--- .. etd change .. filteredFclArr ..---",filteredFclArr)

    if(!date){
      this.getAvailableWeeksForEtd(fclRates)
      this.getAvailableWeeksForEta(fclRates)
      this.setState({filteredFcl: fclRates})
    }else{
      this.getAvailableWeeksForEta(filteredFclArr)
      this.setState({filteredFcl: filteredFclArr})
    }

  };
  
  // ETA WeekPicker Handler
  handleEtaChange = async (date, dateString) => {
    //console.log("handleEtaChange....",date, dateString)
    const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;

    const jsonData =
      (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
      (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
      (!isEmpty(airJSON) && airJSON) ||
      {};
    //console.log("jsonData?.rates?.filteredJson: ",jsonData?.rates?.filteredJson)
    const fclRates = jsonData?.rates?.fcl
    this.setState({etaRange: date })
    this.props.setSelectedEtaRangeSchedule(date)
  
    const selectedCarrier = this.props.selectedCarrier
    //find selectedRange
    const dateRange = this.getDateRange(date);
    this.setState({ selectedEtaRange: dateRange });
    
    const filteredFclArr = await this.props.filterRatesByEtaEtd(date, this.state.etdRange, selectedCarrier);

    if(!date){ 
      this.setState({filteredFcl : fclRates})
      this.getAvailableWeeksForEtd(fclRates);
      this.getAvailableWeeksForEta(fclRates);
    }else{
      this.setState({filteredFcl : filteredFclArr})
      this.getAvailableWeeksForEtd(filteredFclArr);
    }
 
    
  };

  // Component Did Mount
  componentDidMount() {
    const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;

    const jsonData =
      (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
      (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
      (!isEmpty(airJSON) && airJSON) ||
      {};
    
    const jsonItemsArr =
    (!isEmpty(jsonData) &&
      !isEmpty(jsonData.rates) &&
      Array.isArray(
        (jsonData.rates.filteredJson || jsonData.rates.fcl) || jsonData.rates.lcl || jsonData.rates.air
      ) &&
      ((jsonData.rates.filteredJson || jsonData.rates.fcl) || jsonData.rates.lcl || jsonData.rates.air)) ||
    [];
  
    this.getAvailableWeeksForEta(jsonItemsArr);
    this.getAvailableWeeksForEtd(jsonItemsArr);

  }
  componentDidUpdate(prevProps) {
    const prevSelectedCarrier = prevProps.selectedCarrier
    const selectedCarrier = this.props.selectedCarrier
    const { seaFCLJSON, seaLCLJSON, airJSON, queryParams } = this.props;

    const jsonData =
      (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
      (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
      (!isEmpty(airJSON) && airJSON) ||
      {};

    if(prevSelectedCarrier !== selectedCarrier){
      // console.log("--carrier change--prevSelectedCarrier is not empty--", jsonData)
      if(queryParams?.type === "api-fcl" && jsonData?.rates?.fcl){
        this.getAvailableWeeksForEta(jsonData.rates.fcl);
        this.getAvailableWeeksForEtd(jsonData.rates.fcl);
      }

    }
    // Check if schedule_etd_range has changed
    if (prevProps.schedule_etd_range !== this.props.schedule_etd_range) {
      // Only update the state if the value has changed
      if (this.props.schedule_etd_range !== this.state.etdRange) {
        this.setState({
          etdRange: this.props.schedule_etd_range,
        });
        const dateRange = this.getDateRange(this.props.schedule_etd_range);
        this.setState({ selectedEtdRange: dateRange });
      }
    } 


    // Check if schedule_eta_range has changed
    if (prevProps.schedule_eta_range !== this.props.schedule_eta_range) {
      // Only update the state if the value has changed
      if (this.props.schedule_eta_range !== this.state.etaRange) {
        this.setState({
          etaRange: this.props.schedule_eta_range,
        });
        const dateRange = this.getDateRange(this.props.schedule_eta_range);
        this.setState({ selectedEtaRange: dateRange });
      }
    } 

  }

   // Disable dates for ETD WeekPicker based on available weeks for ETD
   disableEtdDate = (current) => {
    return !this.state.availableWeeksForEtd.some(week =>
      moment(current).isBetween(week.startOfWeek, week.endOfWeek, null, '[]')
    );
  };

  // Disable dates for ETA WeekPicker based on available weeks for ETA Destination
  disableEtaDate = (current) => {
    return !this.state.availableWeeksForEtaDestination.some(week =>
      moment(current).isBetween(week.startOfWeek, week.endOfWeek, null, '[]')
    );
  };

  render() {
    return (
      <Card //className='fcl-container-type testO1'
      className="fcl-schedules-filter-container-type" 
      bordered={false}>
      <h4
        style={{
          margin: "4px 0px 8px",
          color: "#43637c",
          fontWeight: "500",
          fontSize: "16px",
        }}
      >
        Filter Rates By Schedules
      </h4>
      <Form>
      <div style={{ paddingtop: '10px' }}>
        <Row gutter={24}>
          {/* ETD WeekPicker */}
          <Col span={24} style={{paddingBottom:"1rem"}}>
            <div>ETD (Estimated Time of Departure)</div>
            <WeekPicker onChange={this.handleEtdChange} placeholder="Select week" disabledDate={this.disableEtdDate}
             value={this.state.etdRange  ? this.state.etdRange : null}
            />
            {
              this.state.selectedEtdRange &&
              <div style={{paddingTop:"10px",paddingBottom: "10px"}}>
                <p style={{fontWeight:"600"}}> Departure Date Range </p>
                <p> {this.state.selectedEtdRange}</p>
              </div>
            }
            
          </Col>

          {/* ETA WeekPicker */}
          <Col span={24}>
            <div>ETA (Estimated Time of Arrival)</div>
            <WeekPicker onChange={this.handleEtaChange} placeholder="Select week" disabledDate={this.disableEtaDate}
             value={this.state.etaRange  ? this.state.etaRange : null}
            />
            {
              this.state.selectedEtaRange &&
              <div style={{paddingTop:"10px"}}>
                {/* <p> Selected ETA </p> */}
                <p style={{fontWeight:"600"}}> Arrival Date Range </p>
                <p> {this.state.selectedEtaRange}</p>
              </div>
            }
          </Col>
        </Row>
      </div>
      </Form>
      </Card>
    );
  }
}

//export default ScheduleRateFilter;
ScheduleRateFilter.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    seaFCLJSON: state.route.seaFCLJSON,
    seaLCLJSON: state.route.seaLCLJSON,
    airJSON: state.route.airJSON,
    queryParams: state.route.queryParams,
    selectedCarrier: state.route.selected_carrier,
    schedule_etd_range: state.route.schedule_etd_range,
    schedule_eta_range: state.route.schedule_eta_range
  };
};

export default connect(mapStateToProps, actions)(ScheduleRateFilter);
